import { storableError } from '../../util/errors';
import { sendSupportEmail as sendSupportEmailAPI, uploadFileToBlob } from '../../util/api';

// ================ Action types ================ //

export const SEND_SUPPORT_REQUEST = 'app/SupportPage/SEND_SUPPORT_REQUEST';
export const SEND_SUPPORT_SUCCESS = 'app/SupportPage/SEND_SUPPORT_SUCCESS';
export const SEND_SUPPORT_ERROR = 'app/SupportPage/SEND_SUPPORT_ERROR';
export const SEND_SUPPORT_CLEAR = 'app/SupportPage/SEND_SUPPORT_CLEAR';

export const BLOB_FILE_UPLOAD_REQUEST = 'app/SupportPage/BLOB_FILE_UPLOAD_REQUEST';
export const BLOB_FILE_UPLOAD_SUCCESS = 'app/SupportPage/BLOB_FILE_UPLOAD_SUCCESS';
export const BLOB_FILE_UPLOAD_ERROR = 'app/SupportPage/BLOB_FILE_UPLOAD_ERROR';

// ================ Reducer ================ //

const initialState = {
  sendSupportInProgress: false,
  sendSupportError: null,
  sendSupportSuccess: false,
  requestToken: null,
  uploadInProgress: false,
  uploadError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SEND_SUPPORT_REQUEST:
      return {
        ...state,
        sendSupportInProgress: true,
        sendSupportError: null,
        sendSupportSuccess: false,
      };
    case SEND_SUPPORT_SUCCESS:
      return {
        ...state,
        sendSupportInProgress: false,
        sendSupportSuccess: true,
        requestToken: payload,
      };
    case SEND_SUPPORT_ERROR:
      return {
        ...state,
        sendSupportInProgress: false,
        sendSupportError: payload,
      };
    case SEND_SUPPORT_CLEAR:
      return {
        ...initialState,
      };
    case BLOB_FILE_UPLOAD_REQUEST:
      return {
        ...state,
        uploadInProgress: true,
        uploadError: null,
      };
    case BLOB_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadInProgress: false,
      };
    case BLOB_FILE_UPLOAD_ERROR:
      return {
        ...state,
        uploadInProgress: false,
        uploadError: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const sendSupportRequest = () => ({ type: SEND_SUPPORT_REQUEST });
export const sendSupportSuccess = requestToken => ({ type: SEND_SUPPORT_SUCCESS, payload: requestToken });
export const sendSupportError = error => ({
  type: SEND_SUPPORT_ERROR,
  payload: error,
  error: true,
});
export const sendSupportClear = () => ({ type: SEND_SUPPORT_CLEAR });

export const uploadBlobFileRequest = () => ({ type: BLOB_FILE_UPLOAD_REQUEST });
export const uploadBlobFileSuccess = () => ({ type: BLOB_FILE_UPLOAD_SUCCESS });
export const uploadBlobFileError = error => ({
  type: BLOB_FILE_UPLOAD_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const sendSupportEmail = formData => (dispatch, getState, sdk) => {
  dispatch(sendSupportRequest());

  return sendSupportEmailAPI(formData)
    .then(res => {
      dispatch(sendSupportSuccess(res.requestToken));
      return res;
    })
    .catch(e => {
      dispatch(sendSupportError(storableError(e)));
      throw e;
    });
};

export const uploadBlobFile = actionPayload => (dispatch, getState, sdk) => {
  const formData = new FormData();
  formData.append('file', actionPayload.file);

  dispatch(uploadBlobFileRequest());

  return uploadFileToBlob(formData)
    .then(res => {
      dispatch(uploadBlobFileSuccess());
      return res;
    })
    .catch(e => {
      dispatch(uploadBlobFileError(storableError(e)));
      throw e;
    });
};
